export class MailtemplateType {
    public static readonly DOCUMENT_CANCELLED = 1;
    public static readonly DOCUMENT_PENDING_SIGNATURE = 2;
    public static readonly DOCUMENT_COMPLETION_ALERT_CHARGE = 3;
    public static readonly SEND_DOCUMENT_ATTACHTMENT = 10; // TODO Plantilla para el envío de adjuntos
    public static readonly SEND_DOCUMENT_2_VISUALIZATION = 20;
    public static readonly VALID_PERSON = 4;
    public static readonly ACKNOWLEDGE_RECEIPT = 30;
}
